import { Redirect, Route, RouteProps } from "react-router-dom";

import { Routes } from "./constants";
import { useAuth } from "./hooks/useAuth";

function ProtectedRoute(props: RouteProps) {
  const { authenticated: userIsAuthenticated } = useAuth();

  if (userIsAuthenticated) {
    console.debug(`User is authenticated. Navigating to "${props.path}"`);
    return <Route {...props}></Route>;
  }

  const nextPage = Routes.LOGIN;
  console.debug(`User is not authenticated. Redirecting to "${nextPage}"`);
  return <Redirect to={nextPage} />;
}

export default ProtectedRoute;
